import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { RegisterComponent } from '../../modules/auth/register/register.component';
import { LoginComponent } from '../../modules/auth/login/login.component';


@Injectable({
    providedIn: 'root'
})
export class AuthDialogService {

    constructor(
        private dialog: MatDialog,
    ) { }

    openRegistrationDialog(): Observable<any> {
        const dialogRef = this.dialog.open(RegisterComponent, {
            minHeight: '600px',
            maxHeight: '98vh',
            width: '500px',
            maxWidth: '96vw',
            disableClose: false,
            exitAnimationDuration: '500ms',
            enterAnimationDuration: '300ms',
            data: []
        });
        return dialogRef.afterClosed();
    }

    openLoginDialog(): Observable<any> {
        const dialogRef = this.dialog.open(LoginComponent, {
            maxHeight: '98vh',
            width: '400px',
            maxWidth: '96vw',
            disableClose: false,
            exitAnimationDuration: '500ms',
            enterAnimationDuration: '300ms',
            data: []
        });
        return dialogRef.afterClosed();
    }
}
